module.exports = __webpack_public_path__ + "static/media/kiosk-dashboard-background.5227facc.jpg";